export enum VisitStatus {
  CHECKIN_IN_PROGRESS = 'CHECKIN_IN_PROGRESS',
  CHECKIN_REJECTED = 'CHECKIN_REJECTED',
  IN = 'IN',
  OUT = 'OUT',
  PRECHECKED_IN = 'PRECHECKED_IN',
  PRECHECKIN_IN_PROGRESS = 'PRECHECKIN_IN_PROGRESS',
}
